import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SaltDepositTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SALT_DEPOSIT;
}

export default SaltDepositTerrainTileEntity;
